"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { TabProvider } from "./TabsContext.mjs";
import cx from "classnames";
import { OverflowCarousel } from "@ingka/carousel";
import { getDTabFromId } from "./utils/index.mjs";
const getFirstPanelId = (tabs) => {
  const firstTab = tabs.find((tab) => tab.props && !tab.props.disabled);
  if (firstTab && firstTab.props)
    return firstTab.props.tabPanelId;
};
const Tabs = (props) => {
  const {
    prefix = "",
    overflowCarouselProps,
    slideIndex,
    onTabChanged,
    rtl,
    defaultActiveTab,
    tabs = [],
    tabPanels,
    className,
    ariaLabel,
    labelledById,
    activeTab,
    subtle = false,
    ...otherProps
  } = props;
  const classes = cx(
    `${prefix}tabs`,
    subtle && `${prefix}tabs--subtle`,
    className
  );
  const root = useRef(null);
  const [_activeTab, setActiveTab] = useState(
    defaultActiveTab || activeTab || getFirstPanelId(tabs)
  );
  const handleTabChange = (tabId) => {
    if (onTabChanged)
      onTabChanged(tabId);
    setActiveTab(tabId);
    const activeDTab = getDTabFromId(tabId);
    if (!activeDTab)
      return;
    const container = activeDTab.parentElement;
    if (!container)
      return;
    const { offsetLeft, clientWidth } = activeDTab;
    const { scrollLeft, offsetWidth } = container;
    if (offsetLeft < scrollLeft || offsetLeft + clientWidth > scrollLeft + offsetWidth)
      container.scrollTo({
        left: activeDTab.offsetLeft - (rtl ? offsetWidth - clientWidth : 0),
        behavior: "smooth"
      });
  };
  useEffect(() => {
    if (activeTab && activeTab !== _activeTab)
      handleTabChange(activeTab);
  }, [activeTab, tabs, onTabChanged]);
  return /* @__PURE__ */ jsx(
    TabProvider,
    {
      value: {
        activeTab: activeTab || _activeTab,
        setActiveTab: handleTabChange,
        tabs,
        root
      },
      children: /* @__PURE__ */ jsxs("div", { ...otherProps, className: classes, ref: root, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            role: "tablist",
            className: `${prefix}tabs__list`,
            "aria-label": ariaLabel,
            "aria-labelledby": labelledById,
            children: /* @__PURE__ */ jsx(
              OverflowCarousel,
              {
                slideIndex,
                rtl,
                prefix,
                ...overflowCarouselProps,
                children: tabs
              }
            )
          }
        ),
        tabPanels
      ] })
    }
  );
};
var Tabs_default = Tabs;
export {
  Tabs_default as default
};
